@if (isLoading) {
  <div class='sideBarContent content loading-spinner'></div>
}
@if (!isLoading) {
  <div class="sideBarContent content">
    <irb-editor-sidebar-banner
      [accordian]="accordian"
      [showUnsavedChangesWarning]="showUnsavedChangesWarning"
      [isModified]="isModified"
      [isValid]="isValid"
      [hasPendingFunction]="hasPendingFunction"
      [slot]="slot"
      (save)="save()"
      (cancel)="cancel()"><span header class="ms-header" tooltip [tooltipTitle]="'Edit Account'" [tooltipRequiresTruncation]="true">Edit Account</span></irb-editor-sidebar-banner>
      <div class="body" [style.height]="bodyHeight" #body>
        <div class="block editorDisplayBanner">
          <div class="left editorDispalybannerHeader">
            <div class="editorDispalybannerText"><p #accountNumber>Account#</p></div>
            <span>{{data?.accountNumber}}</span>
          </div>
          <div class="left editorDispalybannerHeader">
            <div class="editorDispalybannerText"><p #accountName>Account Name</p></div>
            <span>{{data?.accountName}}</span>
          </div>
          <div class="left editorDispalybannerHeader">
            <div class="editorDispalybannerText"><p #type>Type</p></div>
            <span>{{data?.accountsubType}}</span>
          </div>
          <div class="left editorDispalybannerHeader">
            <div class="editorDispalybannerText"><p #taxability>Taxability</p></div>
            <span>{{data?.accountLocationType}}</span>
          </div>
          <div class="left editorDispalybannerHeader">
            <div class="editorDispalybannerText"><p #lastEdit>Date Last Edited / By</p></div>
            @if (data?.modifiedOn!=null) {
              <span>{{data?.modifiedOn | easternTime | date:'MM/dd/yyyy h:mm a'}} ET</span>
            }
            <div>{{data?.modifiedBy}}</div>
          </div>
          <div class="left editorDispalybannerHeader">
            <div class="editorDispalybannerText"><p #totalValue>Total Acct Value</p></div>
            <span>{{data?.marketValue | currency:'USD'}}</span>
          </div>
          <br class="clear"/>
        </div>
        <mat-accordion #accordian="matAccordion" [multi]="true">
          @if (data && ENABLE_ACCOUNT_HISTORY) {
            <mat-expansion-panel id="ACCOUNT_HISTORY"
              [expanded]="ies.getDefaultExpansionState('ACCOUNT_HISTORY')"
              (opened)="ies.updateExpansionState('ACCOUNT_HISTORY','opened')"
              (closed)="ies.updateExpansionState('ACCOUNT_HISTORY','closed')">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Account History
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                <irb-com-account-history [accountId]="data?.accountId"></irb-com-account-history>
              </ng-template>
            </mat-expansion-panel>
          }
          <mat-expansion-panel id="PORTFOLIO_ASSIGNMENT" [expanded]="ies.getDefaultExpansionState('PORTFOLIO_ASSIGNMENT')" (opened)="ies.updateExpansionState('PORTFOLIO_ASSIGNMENT','opened')" (closed)="ies.updateExpansionState('PORTFOLIO_ASSIGNMENT','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Portfolio
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              @if (data) {
                <irb-com-assign-portfolio [(data)]="data" (change)="onInputChange();" (navigate)="showEditPortfolio($event)" [(isModified)]="isModified"></irb-com-assign-portfolio>
              }
            </ng-template>
          </mat-expansion-panel>
          @if (data?.accountsubType !== 'EXTERNAL') {
            <mat-expansion-panel id="SPECIAL_TREATMENT" [expanded]="ies.getDefaultExpansionState('SPECIAL_TREATMENT')" (opened)="ies.updateExpansionState('SPECIAL_TREATMENT','opened')" (closed)="ies.updateExpansionState('SPECIAL_TREATMENT','closed')">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Special Treatment
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                @if (data) {
                  <irb-com-treatment-options [(data)]="data" (change)="onInputChange();"></irb-com-treatment-options>
                }
              </ng-template>
            </mat-expansion-panel>
          }
          @if (data?.isSMAapplicable  && dataTransferService?.ShowSMASymbol) {
            <mat-expansion-panel id="SMA"
              [expanded]="ies.getDefaultExpansionState('SMA')"
              (opened)="ies.updateExpansionState('SMA','opened')"
              (closed)="ies.updateExpansionState('SMA','closed')">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Separately Managed Account
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                <div class="block">
                  <p-checkbox #treatAsSMA name="treatAsSMA" [(ngModel)]="data.isSMA" binary="true" (onChange)="onSmaChange()" inputId="editoracctitem1"></p-checkbox>
                  <label for="editoracctitem1">Treat as SMA</label>
                  <span id="treatAsSMAToolTipIcon" class="infoIcon" calltoaction [calltoactionTemplate]="treatAsSMAToolTipIcon"></span>
                </div>
                @if (data?.isSMA) {
                  <div>
                    <div class="block">
                      <div style="display: inline-block; width: 105px; margin-right: 10px;">SMA Symbol</div>
                      <irb-dropdown-filter #irbSMASymbolDropdown (search)="getSMASymbolItems($event)"
                        size="30" (selection) ="onSMASymbolChange($event)" placeholder ="SMA Symbol"
                      [(value)]="smaSymbol"></irb-dropdown-filter></div>
                      <div>
                        <div style="display: inline-block; width: 105px; margin-right: 10px;">Funding Account</div>
                        <irb-dropdown-filter #irbFundingAccountDropdown (search)="getFundingAccountItems($event)"
                          size="30" (selection) ="onFundingAccountChange($event)" placeholder ="Funding Account"
                        [(value)]="fundingAccount"></irb-dropdown-filter></div>
                      </div>
                    }
                  </ng-template>
                  <ng-template #treatAsSMAToolTipIcon>
                    <div><p>If checked, this account will be handled as a separately managed account.</p><p>The value of this account will be assigned to the SMA symbol you choose and the SMA symbol will be viewed by iRebal as a holding in the SMA funding account that you specify.</p> </div>
                  </ng-template>
                </mat-expansion-panel>
              }
              <mat-expansion-panel id="CASH_NEEDS" [expanded]="ies.getDefaultExpansionState('CASH_NEEDS')" (opened)="ies.updateExpansionState('CASH_NEEDS','opened')" (closed)="ies.updateExpansionState('CASH_NEEDS','closed')">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    Cash Needs
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                  @if (data && setAsideData && globalSettings && !isUiTest) {
                    <irb-com-cash-needs [(data)]="data" [(cashNeedsData)]="setAsideData" [(globalSettings)]="globalSettings" (change)="onInputChange(getCashNeedsIgnoreList());" [(isValid)]="isValid"></irb-com-cash-needs>
                  }
                </ng-template>
              </mat-expansion-panel>
              @if (isExternalAcct && !isUiTest) {
                <mat-expansion-panel id="EXTERNAL_ACCOUNTS"
                  [expanded]="ies.getDefaultExpansionState('EXTERNAL_ACCOUNTS')"
                  (opened)="ies.updateExpansionState('EXTERNAL_ACCOUNTS','opened')"
                  (closed)="ies.updateExpansionState('EXTERNAL_ACCOUNTS','closed')">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      External Accounts
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ng-template matExpansionPanelContent>
                    <irb-com-external-accounts [(data)]="data" (change)="onInputChange();"></irb-com-external-accounts>
                  </ng-template>
                </mat-expansion-panel>
              }
            </mat-accordion>
          </div>
        </div>
      }
